<template>
  <div class="m-payments">
    <h3 class="m-title">
      Payment Methods
    </h3>
    <PaymentWays class="m-payment" />
  </div>
</template>

<script>
import { REGION } from '@ms/config/app'
const PaymentWays = require(`../${REGION}/PaymentWays.vue`).default

export default {
  components: {
    PaymentWays
  }
}
</script>
